import SkeletonBox from "ui-kit/src/Skeleton/SkeletonBox"

export function ClipsSkeleton() {
    const rows = Array.from({ length: 10 }, (_, i) => <SkeletonBox className="clipsSkeleton-clip" key={`${i + 1}-row`} />);
    return (
        <div className="clipsSkeleton-container">
            {rows}
        </div>
    )
}